/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

import { ETextBlockStatus } from '../../../../components/common/TextBlockStatus/textBlockStatusTypes';
import {
    EWizardChangeLockFieldList,
    EWizardChangeLockSteps,
} from '../../../../pages/WizardChangeLock/wizardChangeLockConstant';
import { IWizardChangeLockTranslation } from '../../types/wizards/changeLock';
import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardChangeLockTranslation: IWizardChangeLockTranslation = {
    ...initWizardPropsTranslation,
    [EWizardChangeLockSteps.StepOperationSelection]: {
        lockSubscribers: '',
        selectionInfo: '',
        unlockSubscribers: '',
    },
    [EWizardChangeLockSteps.StepDateSelection]: {
        lockDateFromLabel: '',
        lockDateToLabel: '',
        lockingPeriodInfo: '',
        lockingPeriodLabel: '',
        maxLockingPeriodInfo: '',
        maxUnlockingPeriodInfo: '',
        unlockDateFromLabel: '',
        unlockingPeriodLabel: '',
    },
    [EWizardChangeLockSteps.StepConfirmation]: {
        lockStatus: {
            [ETextBlockStatus.ERROR]: '',
            [ETextBlockStatus.OK]: '',
            [ETextBlockStatus.PARTIALLY]: '',
            [ETextBlockStatus.WARNING]: '',
        },
        onlineCheck: {
            info: '',
            title: '',
        },
        recoveryToList: '',
        removedFromList: '',
        subscriberChangeLockTableTitles: {
            [EWizardChangeLockFieldList.COST]: '',
            [EWizardChangeLockFieldList.MSISDN]: '',
            [EWizardChangeLockFieldList.STATUS]: '',
        },
        unlockStatus: {
            [ETextBlockStatus.ERROR]: '',
            [ETextBlockStatus.OK]: '',
            [ETextBlockStatus.PARTIALLY]: '',
            [ETextBlockStatus.WARNING]: '',
        },
    },
    validateErrors: {
        fillNotify: '',
        lockSubscribersWithErrors: '',
        selectOneSubscribers: '',
        unlockSubscribersWithErrors: '',
    },
    wizardSummary: {
        lockDateFrom: '',
        lockDateTo: '',
        unlockDateFrom: '',
        lockSubscribersAmount: '',
        lockTotalCost: '',
        unlockSubscribersAmount: '',
        unlockTotalCost: '',
    },
    wizardReport: {
        email: '',
        header: '',
        phone: '',
        toSubscribers: '',
        toUser: '',
    },
};
